// ============================================================================
// tokenUtils.js — decodes the base64 pipe-delimited tokens used on the
// self-discovery test links.
//
//   Private: base64("PRIVATE|<testId>|<linkId>|<email>")
//     e.g. "UFJJVkFURXwxOHwxNHxtcmlkdWxwcmFtb2Q5QGdtYWlsLmNvbQ=="
//        -> "PRIVATE|18|14|mridulpramod9@gmail.com"
//     CONFIRMED: first number = testId, second number = linkId.
//     userDetailsId does NOT come from the token — it comes from the
//     logged-in user's /api/access response (see AuthContext's `user`
//     object) and gets combined with linkId in SelfDiscoveryContinue.jsx
//     when calling /api/user/test/validate and /api/user/test/verify-otp.
//
//   Public:  base64("PUBLIC|<linkId>")
//     e.g. "UFVCTElDfDE4" -> "PUBLIC|18"
//     ⚠️ Still unverified whether this single number is a linkId or testId —
//     SelfDiscoveryContinue.jsx currently sends it as `testId` to
//     /api/user/test/common/public/invite. Confirm separately.
// ============================================================================

export const decodeTestToken = (token) => {
  if (!token) return null;
  try {
    const decoded = atob(token);
    const parts = decoded.split("|");
    const [type, ...rest] = parts;

    if (type === "PRIVATE") {
      const [testId, linkId, email] = rest; // confirmed order: testId, linkId, email
      if (!testId || !linkId) return null;
      return { type: "PRIVATE", testId, linkId, email: email || "" };
    }

    if (type === "PUBLIC") {
      const [linkId] = rest;
      if (!linkId) return null;
      return { type: "PUBLIC", linkId };
    }

    return null;
  } catch (e) {
    return null;
  }
};
